/// <amd-module name="typeahead/core/plugins/SuggestionsProvider" />
/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../../typings/typeahead/plugins.d.ts"/>
/// <reference path="../../../typings/typeahead/suggestionsProvider.d.ts"/>
/// <reference path="../../../typings/typeahead/browser.d.ts" />

import {DefaultPluginAssembly} from "typeahead/core/plugins/DefaultPluginAssembly";

export class SuggestionsProvider {
    private readonly suggestionsModifiers: ISuggestionsModifier[] = [];

    constructor(pluginAssembly: IPluginAssembly) {
        this.suggestionsModifiers = pluginAssembly.get(DefaultPluginAssembly.suggestionsModifierIdentifier);
    }

    public modifySuggestions(results: object[], context: IContext, options: any = {}, essAbTests?: string): object[] {
        if (results && results.length > 0 && this.suggestionsModifiers && this.suggestionsModifiers.length > 0) {
            this.suggestionsModifiers.map((suggestionsModifier: ISuggestionsModifier) => {
                return suggestionsModifier.modifySuggestions(results, context, options, essAbTests);
            });
            return results;
        }
        return [];
    }
}
